import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, FileQuestion } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useSeo } from "@/lib/seo";

const LINKS = [
  { to: "/permisos", label: "Permisos y carnets de conducir" },
  { to: "/recuperacion-de-puntos-vigo", label: "Curso de recuperación de puntos" },
  { to: "/curso-cap-vigo", label: "Cursos CAP" },
  { to: "/examen", label: "Test teórico DGT gratis" },
  { to: "/centros", label: "Nuestros 5 centros" },
  { to: "/blog", label: "Blog" },
];

export default function NotFoundPage() {
  useSeo({ title: "Página no encontrada (404) | Autoescuelas Faro" });

  useEffect(() => {
    const m = document.createElement("meta");
    m.setAttribute("name", "robots");
    m.setAttribute("content", "noindex");
    document.head.appendChild(m);
    return () => m.remove();
  }, []);

  return (
    <div data-testid="not-found-page">
      <Header />
      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-24 min-h-[60vh]">
        <div className="flex items-center gap-3 text-[var(--faro-red)] mb-4">
          <FileQuestion size={28} />
          <span className="text-sm font-bold uppercase tracking-[0.2em]">Error 404</span>
        </div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter text-[var(--faro-blue-deep)]">
          Página no encontrada
        </h1>
        <p className="mt-4 text-[var(--faro-text-soft)] text-base">
          La dirección que buscas no existe o ha cambiado. Estas páginas pueden ayudarte:
        </p>
        <ul className="mt-8 space-y-3">
          {LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`notfound-link-${l.to.replace(/\//g, "") || "home"}`}
                className="inline-flex items-center gap-2 font-bold text-[var(--faro-blue)] hover:text-[var(--faro-red)] transition-colors"
              >
                <ArrowRight size={16} /> {l.label}
              </Link>
            </li>
          ))}
        </ul>
        <Link
          to="/"
          data-testid="notfound-home-cta"
          className="mt-10 inline-flex items-center gap-2 rounded-full bg-[var(--faro-blue)] text-white font-bold px-6 py-3 hover:bg-[var(--faro-red)] transition-colors"
        >
          <MapPin size={18} /> Volver a la página de inicio
        </Link>
      </main>
      <Footer />
    </div>
  );
}
